module.exports = __webpack_public_path__ + "img/lab_chem.ad90b9ee.png";